// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".navigation-auth__icon-button{color:#000 !important}.user-dropdown{background:#fff}.user-dropdown__item{font-size:16px !important;display:block;width:100%;padding:.25rem 1.5rem;clear:both;font-weight:400;color:#212529;text-align:inherit;background-color:transparent;border:0;width:172px;height:42px;display:flex;justify-content:start;align-items:center}.user-dropdown__item:hover{background-color:#727cf5;color:#fff}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
